import { useCallback } from 'react';
import { useConfig } from '@cp/shared/config';
import { loadScript } from '@cp/utils/browser/script';

export type CPCryptogramFactory = (values: {
  name?: string;
  cvv: string;
  cardNumber: string;
  expDateMonth?: string;
  expDateYear?: string;
  expDateMonthYear?: string;
}) => Promise<string>;

export const useCloudpaymentsCryptogram = (): CPCryptogramFactory => {
  const config = useConfig();
  return useCallback<CPCryptogramFactory>(
    (values) => {
      return new Promise<void>((resolve) => {
        const verifier = () => 'cp' in window && typeof window.cp.Checkout === 'function';
        if (verifier()) {
          return resolve();
        }
        return loadScript('https://checkout.cloudpayments.ru/checkout.js', {
          verifier,
        });
      }).then(() =>
        new window.cp.Checkout({
          publicId: config.getOrThrow('CLOUDPAYMENTS_PUBLIC_ID'),
        }).createPaymentCryptogram(values),
      );
    },
    [config],
  );
};
